import { merchantsAdapter } from "./slice";

import type { RootState } from "../store";

const selectState = (state: RootState) => state.merchants;

export const {
  selectAll: selectMerchants,
  selectById: selectMerchantById,
  selectIds: selectMerchantIds,
  selectEntities: selectMerchantsEntities,
} = merchantsAdapter.getSelectors(selectState);
